var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.type === 'dots')?_c('div',{staticClass:"spinner--vertical"},[_c('div',{staticClass:"bounce1"}),_c('div',{staticClass:"bounce2"}),_c('div',{staticClass:"bounce3"})]):_c('v-progress-circular',{staticClass:"mt-3 mb-3",attrs:{"size":_vm.size,"width":3,"indeterminate":"","color":"blue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }